export interface Role {
  id: number;
}
